module.exports = __webpack_public_path__ + "static/img/h5code.7af323d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/common/h5code.jpg
// module id = xFQy
// module chunks = 44